import at from 'lodash/at';
import React, { ChangeEvent } from 'react';

import { ValueBox, ValueInput } from '@candu-ai/craft/ui';
import { CallbackAction } from 'craft/types';

import { InteractionFieldProps } from './interactionFields';

export const CallbackField = ({
  defaultValue,
  onChange,
}: InteractionFieldProps<CallbackAction['handler']>) => {
  const onChangeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    return onChange({ ...defaultValue, name: value });
  };

  return (
    <ValueBox isInGroup={{ isLast: true }}>
      <ValueInput
        placeholder="Callback Name"
        value={at(defaultValue as any, 'name')[0]}
        onChange={onChangeHandler}
      />
    </ValueBox>
  );
};
